import React from "react";
import { Form, Icon, Input, Button, Checkbox, Spin, notification } from "antd";
import { Link, Redirect } from "react-router-dom";
import { hot } from "react-hot-loader";
import { connect } from "dva";
import { UsersApi } from "../../services/generated-sdk";
import { getAPIConfig } from "../../service-config";
import { getEmailRegex, useQuery } from "../../utils/common";
import { withOktaAuth } from "@okta/okta-react";
import * as _ from "lodash";
const _validateEmail = email => {
  var re = getEmailRegex();
  return re.test(String(email).toLowerCase());
};
class SsoLoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loginMethod: null,
      loginWithOkta: null,
      isValidUser: true,
      hasOktaAllowed: true
      // allowed: []
    };
    this.passwordRef = React.createRef();
    this.params = useQuery(props.location);
  }

  loginFromJwt = async jwt => {
    const api = new UsersApi(getAPIConfig(jwt));
    try {
      const user = await api.getMyUser();
      const userAltFormat = {
        jwt: state.jwt,
        user: user
      };
      this.props.dispatch({
        type: "app/afterLogin",
        payload: { user: userAltFormat, storeSession: true, remember: true }
      });
      //storeUserSession(userAltFormat, expiry);
      this.props.history.push("/projects");
      //redirectToAccount();
    } catch (e) {
      console.error(e);
    }
  };

  loginWithOKT = () => {
    // console.log({ authS: this.props.authService });
    this.props.authService.login("/");
  };

  tryOktaLogin = async (email = null) => {
    email = _.get(this.props.history, "location.state.email");
    // console.log({ tryOktaLogin_check: email });
    if (email && email.trim().length && _validateEmail(email.trim())) {
      // console.log("email validated...................");
    } else {
      return;
    }
    if (!this.state.isValidUser) {
      return;
    }
    try {
      const API = new UsersApi();
      const method = await API.getUserLoginMethod({
        email
      });
      console.log({ method, PP: this.props });
      if (method) {
        let mData =
          method && method.methodInfo && method.methodInfo.length
            ? method.methodInfo
            : "false";
        // console.log({ mData });
        localStorage.setItem("userLoginMethodDetails", mData);
        this.props.dispatch({
          type: "app/setSsoInfo",
          payload: {
            ssoInfo: JSON.parse(mData)
          }
        });
        if (method.method === "okta") {
          // method is okta
          // if (method.isAdmin) {
          //   // if (this.state.loginWithOkta === true) {
          //     this.props.history.push({
          //       pathname: "/okta-login",
          //       state: { email: email }
          //     });
          //     window.location.reload();
          //     return;
          //   // }
          //   // method.allowed.push("okta");
          //   // this.setState({ loginMethod: "local" });
          //   // this.login(values);
          // } else {
          this.props.history.push({
            pathname: "/okta-login",
            state: { email: email }
          });
          window.location.reload();
          return;
          // }
        } else {
          // if (this.state.loginWithOkta === true) {
          // User chose login with okta
          if (
            method.allowed &&
            method.allowed instanceof Array &&
            method.allowed.includes("okta")
          ) {
            this.props.history.push({
              pathname: "/okta-login",
              state: { email: email }
            });
            window.location.reload();
            return;
          } else {
            notification.warning({
              message: "Your organization does not have OKTA enabled!"
            });
            this.setState({ loginWithOkta: false, hasOktaAllowed: false });
            // this.props.form.setFields({
            //   userName: {
            //     value: email,
            //     errors: [
            //       new Error(
            //         "Your organization does not have OKTA enabled!"
            //       )
            //     ]
            //   }
            // });
            // if (this.passwordRef) this.passwordRef.current.focus();
            return;
          }
          // }
        }
      }
    } catch (e) {
      console.log({ tryOktaLogin_error: e });
      this.setState({ isValidUser: false });
      if (e.json) {
        e.json().then(data => {
          notification.error({
            message: data.message
          });
        });
      }
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    console.log("Form submitted...........");
    this.props.form.validateFields(async (err, values) => {
      console.log({ err, values });
      if (!err) {
        // if (!this.state.loginMethod) {
        // Get user's login loginMethod
        try {
          const API = new UsersApi();
          const method = await API.getUserLoginMethod({
            email: values.userName
          });
          // console.log({ method, PP: this.props });
          if (method) {
            let mData =
              method && method.methodInfo && method.methodInfo.length
                ? method.methodInfo
                : "false";
            // console.log({ mData });
            localStorage.setItem("userLoginMethodDetails", mData);
            this.props.dispatch({
              type: "app/setSsoInfo",
              payload: {
                ssoInfo: JSON.parse(mData)
              }
            });
            if (method.method === "okta") {
              // method is okta
              // if (method.isAdmin) {
              //   if (this.state.loginWithOkta === true) {
              //     this.props.history.push({
              //       pathname: "/okta-login",
              //       state: { email: values.userName }
              //     });
              //     window.location.reload();
              //     return;
              //   }
              //   method.allowed.push("okta");
              //   this.setState({ loginMethod: "local" });
              //   this.login(values);
              // } else {
              this.props.history.push({
                pathname: "/okta-login",
                state: { email: values.userName }
              });
              window.location.reload();
              return;
              // }
            } else {
              // if (this.state.loginWithOkta === true) {
              // User chose login with okta
              if (
                method.allowed &&
                method.allowed instanceof Array &&
                method.allowed.includes("okta")
              ) {
                this.props.history.push({
                  pathname: "/okta-login",
                  state: { email: values.userName }
                });
                window.location.reload();
                return;
              } else {
                // this.setState({ loginWithOkta: false });
                this.props.form.setFields({
                  userName: {
                    value: values.userName,
                    errors: [
                      new Error("Your organization does not have OKTA enabled!")
                    ]
                  }
                });
                this.setState({ hasOktaAllowed: false });
                // if (this.passwordRef) this.passwordRef.current.focus();
                return;
              }
              // }
            }
            // if (method.allowed && method.allowed instanceof Array) {
            //   this.setState(
            //     { allowed: method.allowed, loginMethod: "local" },
            //     () => {
            //       // if(this.passwordRef) this.passwordRef.current.focus();
            //       this.login(values);
            //     }
            //   );
            // } else {
            //   this.setState({ loginMethod: "local" }, () => {
            //     this.login(values);
            //   });
            // }
            return;
          } else {
            // this.setState({ loginWithOkta: false });
            this.props.form.setFields({
              userName: {
                value: values.userName,
                errors: [
                  new Error("Your organization does not have OKTA enabled!")
                ]
              }
            });
            this.setState({ hasOktaAllowed: false });
          }
        } catch (error) {
          console.log({ error });
          if (error.json) {
            error.json().then(data => {
              // handleError(data.statusCode, {}, data.message || "");
              notification.error({
                message: data.message
              });
            });
          }
          this.setState({ isValidUser: false, hasOktaAllowed: false });
          // this.setState({ loginMethod: "local" });
          return;
        }
        // }
        // this.login(values);
      }
    });
  };

  login = values => {
    this.setState({ loading: true });
    this.props.dispatch({
      type: "app/login",
      payload: {
        email: values.userName,
        password: values.password,
        remember: values.remember,
        callback: () => this.setState({ loading: false })
      }
    });
  };

  // onOktaLogin = e => {
  //   if (this.props.form.getFieldValue("userName")) {
  //     // Email is already entered
  //     this.setState({ loginWithOkta: true }, () => {
  //       this.handleSubmit(e);
  //     });
  //     return;
  //   }
  //   this.setState({ loginWithOkta: true });
  // };

  componentDidMount() {
    if (this.state.isValidUser && this.state.hasOktaAllowed) {
      this.tryOktaLogin();
    }
  }

  render() {
    //console.log(this.props);
    const { getFieldDecorator } = this.props.form;
    const { loginMethod } = this.state;

    // if (this.state.isValidUser && this.state.hasOktaAllowed) {
    //   this.tryOktaLogin();
    // }
    //console.log(this.props.app)
    if (this.props.app.loggedIn) {
      // 1. Login rule #1: check if redirection url exists in storage

      const redirectTo = this.params.get("redirect");
      const reqURL = sessionStorage.getItem("TC_REDIR_URL")
        ? sessionStorage.getItem("TC_REDIR_URL")
        : redirectTo;
      const search = sessionStorage.getItem("TC_REDIR_SEARCH");
      if (reqURL) {
        sessionStorage.removeItem("TC_REDIR_URL");
        //Storage.remove("TC_REDIR_URL")
        return (
          <Redirect
            to={{
              pathname: reqURL,
              search,
              state: { isModal: true, entry: true }
            }}

            // location={{ state: { isModal: true, entry: true } }}
          />
        );
      }

      let redirURL;

      // 2. Login Rule #2: if user has multiple companies, show option to pick them (partyle implemented in AppModel)
      // console.log(
      //   "comps",
      //   this.props.app.company,
      //   Object.keys(this.props.app.company).length
      // );

      redirURL = "/tasks";

      if (
        this.props.app.loggedInUser &&
        this.props.app.loggedInUser["role"] &&
        typeof this.props.app.loggedInUser["role"] === "object" &&
        this.props.app.loggedInUser["role"]["name"] === "Administrator"
      ) {
        redirURL = "/projects";
      }
      // const userPref = JSON.parse(this.props.app.loggedInUser.preferences);
      // //console.log({userPref})
      // if (typeof userPref == "object") {
      //   const sortedProjects = _.sortBy(userPref.last_accessed_projects, [
      //     "last_accessed"
      //   ]);
      //   //console.log(sortedProjects)
      //   const lastProject = sortedProjects.pop();
      //   //console.log({ lastProject });
      //   if (lastProject != undefined)
      //     redirURL = `/project/${lastProject.project_id}`;
      // }

      //return <div>{redirURL}</div>;

      if (
        this.props.location.search.indexOf("AttachmentView") &&
        this.props.location.search.indexOf("reqURL")
      ) {
        redirURL = this.props.location.search.replace(
          "?redirectTo=AttachmentView&reqURL=",
          ""
        );
        //console.log({redirURL});
      }

      return <Redirect to={redirURL} />;
    }
    return (
      <div className="login_page">
        <div className="login_wrapper">
          <div className="fs-exclude">
            <h1>Welcome Back 🙂</h1>
            Please login to your account
            <br />
            <br />
            <br />
            <Form onSubmit={this.handleSubmit} className="login-form">
              <Form.Item>
                {getFieldDecorator("userName", {
                  rules: [
                    { required: true, message: "Please input your email!" },
                    {
                      pattern: getEmailRegex(),
                      message: "Invalid email address"
                    }
                  ],
                  validateTrigger: "onBlur",
                  initialValue: _.get(
                    this.props.history,
                    "location.state.email"
                  )
                    ? _.get(this.props.history, "location.state.email")
                    : ""
                })(
                  <Input
                    prefix={
                      !loginMethod && (
                        <Icon
                          type="user"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      )
                    }
                    placeholder="Email"
                    size="large"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  loading={this.state.loading}
                  type="primary"
                  htmlType="submit"
                  className="btn-success"
                  style={{ width: "50%", marginTop: "30px", height: "42px" }}
                >
                  Log in
                </Button>
                <br />
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const WrappedSsoLoginForm = Form.create({ name: "sso_login" })(SsoLoginForm);

function mapStateToProps(state, ownProps) {
  return {
    app: state.app,
    ...ownProps
  };
}

const SsoLogin = connect(mapStateToProps)(WrappedSsoLoginForm);
export default hot(module)(withOktaAuth(SsoLogin));
